
import { useState } from "react";
import _ from "lodash";
import { format } from "date-fns";

import reportApi from "../../api/reportApi";
import { dataValidator } from "../../tools/dataValidator";
import useMount from '../../hooks/useMount';
import { getLabel, getLanguage } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import ReportStatus from "./ReportStatus";

const ReportModal = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const Status = props.Status;
  const OnCloseModal = props.OnCloseModal;
  const LoadData = props.LoadData;

  //State
  const [report, setReport] = useState(undefined);
  const [form, setForm] = useState(undefined);
  const [error, setError] = useState({});
  const [changeStatus, setChangeStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isUpdate] = useState(Id && Id != 0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const baseForm = {
    _id: 0
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {

    if (isUpdate){

      try{

        setLoading(true);

        let response = await reportApi.getReport(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }


        setReport(response.Data);
        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      //Add
      setForm(baseForm);
      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };

  const onChangeStatus = async(_data) => {

    try
    {

      setLoading(true);


      let parameters = {
        _id: report._id,
        status: _data.code
      };

      let response = await reportApi.updateReportStatus(parameters);

      if (!response.Success)
      {


        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label, response.Error.parameter) : undefined;

        throw error;

      }


      await LoadData();

      setLoading(false);


      OnCloseModal();


    } catch (err)
    {

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };



  if (!report) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ReportPage", "Report")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {changeStatus && 
          <ReportStatus
            IsDesktop={IsDesktop}
            Data={report}
            Status={Status}
            OnCloseModal={() => setChangeStatus(false)}
            OnClickSave={onChangeStatus}
          />
        }
        <div className="page_modal_header_cont" style={{marginBottom: "10px"}}>
          {getLabel("ReportPage", "Report")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Report", "process")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.process.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Product Category")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.product.category || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Product Type")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.product.type || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Product Category")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.product.category || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Product Model")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.product.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "User Email")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.user.email || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "User Name")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.user.firstName + " " + report.user.lastName || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Report Status")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.status.label[getLanguage()] || report.status.label["EN"] || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Report Date")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={format(report.createdAt, 'yyyy-MM-dd HH:mm') || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Step Title")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={report.step.title || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ReportPage", "Issue")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <textarea
                className={"page_textarea_input "}
                rows={10}
                value={report.description || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title" style={{width: "100%", justifyContent: "center"}}>
              Path
            </div>
          </div>
          <div className="report_path_cont">
            {report.path.map((p, pIndex) => (
              <div className="report_path_step" key={pIndex}>
                {p.title}
                {p.component.map((c, cIndex) => (
                  <div className="report_path_component_cont" key={cIndex}>
                    <div className="report_path_component_title">
                      {c.title}
                    </div>
                    <div className="report_path_component_value">
                      {c.value}
                    </div>
                  </div>
                ))}

              </div>
            ))}
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("ReportPage", "Change Status")}
            style={{ maxWidth: "200px" }}
            onClick={(loading) ? undefined : () => setChangeStatus(true)}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ReportModal;